export const salaryTranslations = {
  // Salary Settings View
  'salary.title': {
    en: 'Salary Settings',
    fi: 'Palkka-asetukset'
  },
  'salary.integrationSettings': {
    en: 'Integration Settings',
    fi: 'Integraatioasetukset'
  },

  // Integration Settings
  'salary.integration.title': {
    en: 'Integration Settings',
    fi: 'Integraatioasetukset'
  },
  'salary.integration.organizationId': {
    en: 'Organization ID / Business ID',
    fi: 'Organisaatiotunniste / Y-tunnus'
  },
  'salary.integration.organizationIdPlaceholder': {
    en: '1234567-8',
    fi: '1234567-8'
  },
  'salary.integration.customerId': {
    en: 'Customer ID',
    fi: 'Customer ID'
  },
  'salary.integration.customerIdPlaceholder': {
    en: 'Enter Customer ID',
    fi: 'Syötä Customer ID'
  },
  'salary.integration.customerKey': {
    en: 'Customer Key',
    fi: 'Customer Key'
  },
  'salary.integration.customerKeyPlaceholder': {
    en: 'Input Customer Key',
    fi: 'Syötä Customer Key'
  },
  'salary.integration.partnerId': {
    en: 'Partner ID',
    fi: 'Partner ID'
  },
  'salary.integration.partnerIdPlaceholder': {
    en: 'Enter Partner ID',
    fi: 'Syötä Partner ID'
  },
  'salary.integration.partnerKey': {
    en: 'Partner Key',
    fi: 'Partner Key'
  },
  'salary.integration.partnerKeyPlaceholder': {
    en: 'Input Partner Key',
    fi: 'Syötä Partner Key'
  },
  'salary.integration.sender': {
    en: 'Sender',
    fi: 'Sender'
  },
  'salary.integration.invoiceNumber': {
    en: 'Invoice number (number from which the next invoice starts)',
    fi: 'Laskunumero (numero, josta seuraava lasku alkaa)'
  },
  'salary.integration.invoiceNumberPlaceholder': {
    en: 'Enter invoice number',
    fi: 'Syötä laskunumero'
  },
  'salary.integration.senderPlaceholder': {
    en: 'Sender identifier',
    fi: 'Lähettäjän tunnus'
  },
  'salary.integration.baseUrl': {
    en: 'Base URL',
    fi: 'Base URL'
  },
  'salary.integration.baseUrlPlaceholder': {
    en: 'https://isvapi.netvisor.fi',
    fi: 'https://isvapi.netvisor.fi'
  },
  'salary.integration.language': {
    en: 'Language',
    fi: 'Kieli'
  },
  'salary.integration.languagePlaceholder': {
    en: 'FI',
    fi: 'FI'
  },
  'salary.integration.saveSettings': {
    en: 'Save Settings',
    fi: 'Tallenna asetukset'
  },
  'salary.integration.saving': {
    en: 'Saving...',
    fi: 'Tallennetaan...'
  },
  'salary.integration.settingsSaved': {
    en: 'Settings saved successfully',
    fi: 'Asetukset tallennettu onnistuneesti'
  },
  'salary.integration.saveFailed': {
    en: 'Failed to save settings',
    fi: 'Asetusten tallennus epäonnistui'
  },

  // Person Mapping
  'salary.personMapping.title': {
    en: 'Person Mapping',
    fi: 'Henkilöiden yhdistäminen'
  },
  'salary.personMapping.description': {
    en: 'Map SkillHub persons to payroll system employees.',
    fi: 'Yhdistä SkillHubin henkilöt taloushallintojärjestelmän palkansaajiin.'
  },
  'salary.personMapping.identifiersEntered': {
    en: 'identifiers entered',
    fi: 'tunnistetta syötetty'
  },
  'salary.personMapping.missingIdentifiers': {
    en: 'persons are missing employee identifier.',
    fi: 'henkilöltä puuttuu palkansaajan tunniste.'
  },
  'salary.personMapping.duplicateIdentifiers': {
    en: 'identifiers appear on multiple persons.',
    fi: 'tunniste esiintyy useammalla henkilöllä.'
  },
  'salary.personMapping.searchPlaceholder': {
    en: 'Search person...',
    fi: 'Hae henkilöä...'
  },
  'salary.personMapping.skillhubPerson': {
    en: 'SkillHub Person',
    fi: 'SkillHub-henkilö'
  },
  'salary.personMapping.employeeIdentifier': {
    en: 'Employee Identifier',
    fi: 'Palkansaajan tunniste'
  },
  'salary.personMapping.enterIdentifier': {
    en: 'Enter identifier...',
    fi: 'Syötä tunniste...'
  },
  'salary.personMapping.noResults': {
    en: 'No search results for',
    fi: 'Ei hakutuloksia haulle'
  },
  'salary.personMapping.saveMappings': {
    en: 'Save Mappings',
    fi: 'Tallenna yhdistämiset'
  },
  'salary.personMapping.saving': {
    en: 'Saving...',
    fi: 'Tallennetaan...'
  },
  'salary.personMapping.mappingsSaved': {
    en: 'Mappings saved',
    fi: 'Yhdistämiset tallennettu'
  },
  'salary.personMapping.mappingsFailed': {
    en: 'Failed to save mappings',
    fi: 'Yhdistämisten tallennus epäonnistui'
  },
  'salary.personMapping.loadFailed': {
    en: 'Failed to load experts',
    fi: 'Asiantuntijoiden lataus epäonnistui'
  },

  // Salary Type Mapping
  'salary.salaryTypeMapping.title': {
    en: 'Salary Type Mapping',
    fi: 'Palkkalajien kohdistus'
  },
  'salary.salaryTypeMapping.description': {
    en: 'Define salary types, coefficients and accounting identifiers for payroll data transfer',
    fi: 'Määritä palkkalajit, kertoimet ja kirjanpitotunnisteet palkka-aineiston siirtoa varten'
  },
  'salary.salaryTypeMapping.salaryTypes': {
    en: 'salary types',
    fi: 'palkkalajia'
  },
  'salary.salaryTypeMapping.defaultSalaryTypes': {
    en: 'default',
    fi: 'oletuksena'
  },
  'salary.salaryTypeMapping.name': {
    en: 'Name',
    fi: 'Nimi'
  },
  'salary.salaryTypeMapping.costCoefficient': {
    en: 'Cost Coefficient',
    fi: 'Omakustannuskerroin'
  },
  'salary.salaryTypeMapping.collectorRatio': {
    en: 'Accounting Identifier',
    fi: 'Kirjanpitotunniste'
  },
  'salary.salaryTypeMapping.namePlaceholder': {
    en: 'Salary type name',
    fi: 'Palkkalajin nimi'
  },
  'salary.salaryTypeMapping.collectorRatioPlaceholder': {
    en: '—',
    fi: '—'
  },
  'salary.salaryTypeMapping.addSalaryType': {
    en: 'Add Salary Type',
    fi: 'Lisää palkkalaji'
  },
  'salary.salaryTypeMapping.deleteConfirmation': {
    en: 'Click again to delete',
    fi: 'Klikkaa uudelleen poistaaksesi'
  },
  'salary.salaryTypeMapping.deleteRow': {
    en: 'Delete row',
    fi: 'Poista rivi'
  },
  'salary.salaryTypeMapping.deleteRequiresConfirmation': {
    en: 'Deletion requires a second click for confirmation.',
    fi: 'Poistaminen vaatii toisen klikkauksen vahvistukseksi.'
  },
  'salary.salaryTypeMapping.saveSalaryTypes': {
    en: 'Save Salary Types',
    fi: 'Tallenna palkkalajit'
  },
  'salary.salaryTypeMapping.saving': {
    en: 'Saving...',
    fi: 'Tallennetaan...'
  },
  'salary.salaryTypeMapping.salaryTypesSaved': {
    en: 'Salary types saved',
    fi: 'Palkkalajit tallennettu'
  },
  'salary.salaryTypeMapping.saveFailed': {
    en: 'Failed to save salary types',
    fi: 'Palkkalajien tallennus epäonnistui'
  },
  'salary.salaryTypeMapping.loadFailed': {
    en: 'Failed to load salary types',
    fi: 'Palkkalajien lataus epäonnistui'
  },

  // Salary Formation View
  'salary.formation.title': {
    en: 'Salary Data',
    fi: 'Palkka-aineisto'
  },
  'salary.formation.description': {
    en: 'Generate and send salary data to the accounting system for the selected time period',
    fi: 'Muodosta ja lähetä palkka-aineisto taloushallintojärjestelmään valitulta aikaväliltä'
  },
  'salary.formation.filterCriteria': {
    en: 'Filter Criteria',
    fi: 'Hakuehdot'
  },
  'salary.formation.dateRange': {
    en: 'Time Period',
    fi: 'Aikaväli'
  },
  'salary.formation.persons': {
    en: 'persons',
    fi: 'henkilöä'
  },
  'salary.formation.allPersons': {
    en: 'All persons',
    fi: 'Kaikki henkilöt'
  },
  'salary.formation.missingEmployeeIdentifier': {
    en: 'No employee identifier',
    fi: 'Ei palkansaajan tunnistetta'
  },
  'salary.formation.generatePreview': {
    en: 'Generate Preview',
    fi: 'Muodosta esikatselu'
  },
  'salary.formation.generatingPreview': {
    en: 'Generating preview...',
    fi: 'Muodostetaan esikatselua...'
  },
  'salary.formation.loadingEntries': {
    en: 'Fetching approved time entries...',
    fi: 'Haetaan hyväksyttyjä tuntikirjauksia...'
  },
  'salary.formation.entriesLoaded': {
    en: 'entries loaded',
    fi: 'kirjausta ladattu'
  },
  'salary.formation.loadFailed': {
    en: 'Failed to load time entries',
    fi: 'Tuntikirjausten lataus epäonnistui'
  },
  'salary.formation.preview': {
    en: 'Preview',
    fi: 'Esikatselu'
  },
  'salary.formation.blockingErrors': {
    en: 'blocking errors',
    fi: 'estävää virhettä'
  },
  'salary.formation.errorWarning': {
    en: 'the transfer cannot be completed until the errors are fixed. Check the person mapping to accounting system employees.',
    fi: 'lähetystä ei voi tehdä ennen kuin virheet on korjattu. Tarkista henkilöiden yhdistäminen taloushallintojärjestelmän palkansaajiin.'
  },
  'salary.formation.days': {
    en: 'Days',
    fi: 'Päivää'
  },
  'salary.formation.rows': {
    en: 'Rows',
    fi: 'Riviä'
  },
  'salary.formation.employee': {
    en: 'Employee',
    fi: 'Työntekijä'
  },
  'salary.formation.date': {
    en: 'Date',
    fi: 'Päivämäärä'
  },
  'salary.formation.salaryType': {
    en: 'Salary Type',
    fi: 'Palkkalaji'
  },
  'salary.formation.accountingId': {
    en: 'Accounting Identifier',
    fi: 'Kirjanpitotunniste'
  },
  'salary.formation.amount': {
    en: 'Amount',
    fi: 'Määrä'
  },
  'salary.formation.entryDescription': {
    en: 'Description',
    fi: 'Kuvaus'
  },
  'salary.formation.status': {
    en: 'Status',
    fi: 'Tila'
  },
  'salary.formation.sending': {
    en: 'Sending...',
    fi: 'Lähetetään...'
  },
  'salary.formation.sendToAccounting': {
    en: 'Send to Accounting',
    fi: 'Lähetä taloushallintoon'
  },
  'salary.formation.regeneratePreview': {
    en: 'Regenerate Preview',
    fi: 'Muodosta esikatselu uudelleen'
  },
  'salary.formation.sendComplete': {
    en: 'Transfer Complete',
    fi: 'Lähetys valmis'
  },
  'salary.formation.successful': {
    en: 'Successful',
    fi: 'Onnistui'
  },
  'salary.formation.failed': {
    en: 'Failed',
    fi: 'Epäonnistui'
  },
  'salary.formation.unclear': {
    en: 'Unclear',
    fi: 'Epäselvä'
  },
  'salary.formation.transferLog': {
    en: 'Transfer Log',
    fi: 'Siirtoloki'
  },
  'salary.formation.person': {
    en: 'Person',
    fi: 'Henkilö'
  },
  'salary.formation.hours': {
    en: 'Hours',
    fi: 'Tunteja'
  },
  'salary.formation.result': {
    en: 'Result',
    fi: 'Tulos'
  },
  'salary.formation.message': {
    en: 'Message',
    fi: 'Viesti'
  },
  'salary.formation.back': {
    en: 'Back',
    fi: 'Takaisin'
  },
  'salary.formation.sentSuccessfully': {
    en: 'Transferred successfully',
    fi: 'Siirretty onnistuneesti'
  },
  'salary.formation.sendFailed': {
    en: 'Transfer failed',
    fi: 'Siirto epäonnistui'
  },

  // Netvisor Logs View
  'salary.logs.title': {
    en: 'Netvisor Transfer History',
    fi: 'Netvisor-siirtohistoria'
  },
  'salary.logs.description': {
    en: 'View history of salary data transfers to Netvisor',
    fi: 'Tarkastele palkkatietojen siirtohistoriaa Netvisoriin'
  },
  'salary.logs.loading': {
    en: 'Loading transfer history...',
    fi: 'Ladataan siirtohistoriaa...'
  },
  'salary.logs.loadFailed': {
    en: 'Failed to load transfer history',
    fi: 'Siirtohistorian lataus epäonnistui'
  },
  'salary.logs.noLogs': {
    en: 'No transfer history found for this period',
    fi: 'Tälle ajanjaksolle ei löytynyt siirtohistoriaa'
  },
  'salary.logs.previousYear': {
    en: 'Previous Year',
    fi: 'Edellinen vuosi'
  },
  'salary.logs.nextYear': {
    en: 'Next Year',
    fi: 'Seuraava vuosi'
  },
  'salary.logs.statistics': {
    en: 'Statistics',
    fi: 'Tilastot'
  },
  'salary.logs.totalEntries': {
    en: 'Total Entries',
    fi: 'Merkintöjä yhteensä'
  },
  'salary.logs.batch': {
    en: 'Batch',
    fi: 'Erä'
  },
  'salary.logs.individualEntries': {
    en: 'Individual Entries',
    fi: 'Yksittäiset merkinnät'
  },
  'salary.logs.entries': {
    en: 'entries',
    fi: 'merkintää'
  },
  'salary.logs.timestamp': {
    en: 'Timestamp',
    fi: 'Aikaleima'
  }
};
